export function formatViewCount(count: number): string {
  if (count < 1000) {
    return count.toString();
  }

  if (count < 10_000) {
    // 1k – 9.9k → 1 decimal
    const value = Math.floor(count / 100) / 10;
    return `${value}k`;
  }

  if (count < 1_000_000) {
    // 10k – 999k → hele k
    const value = Math.floor(count / 1000);
    return `${value}k`;
  }

  // 1m+
  if (count < 10_000_000) {
    // 1m – 9.9m → 1 decimal
    const value = Math.floor(count / 100_000) / 10;
    return `${value}m`;
  }

  // 10m+
  const value = Math.floor(count / 1_000_000);
  return `${value}m`;
}
